import * as React from 'react';
import {
    CMTextSizeExperiment,
    TImprovedContentMarketing,
} from '../../../../shared/types/contentMarketing';
import { getConfig, getExperimentVariantFromConfig } from '../../../config';
import { UNLEASH_FEATURE_NAMES } from '../../../../shared/unleash/feature-names';
import { useRef } from 'react';
import { useTextBalancer } from '../../../hooks/text-balance';

type ContentMarketingTextContainerType = {
    smallText?: boolean;
    contentMarketing: TImprovedContentMarketing;
};

const TextContainer = ({
    contentMarketing,
    smallText,
}: ContentMarketingTextContainerType) => {
    const title = contentMarketing.title.replace(/\\n/g, '<br/>');

    const textSizeCarExperiment = getExperimentVariantFromConfig(
        UNLEASH_FEATURE_NAMES.contentMarketingTextSize,
    ) as CMTextSizeExperiment;

    const ref = useRef<HTMLParagraphElement>();
    const { vertical } = getConfig();
    useTextBalancer(ref, textSizeCarExperiment, vertical !== 'car');

    return (
        <div>
            {Boolean(contentMarketing.sponsorData.name) && (
                <div className={`text-gray-500 text-14 mb-4`}>
                    <span>{contentMarketing.sponsorData.name}</span>
                </div>
            )}
            <h2
                className={`${
                    smallText ? 'h4' : 'h3'
                } text-left font-normal mb-0 whitespace-pre-wrap text-ellipsis no-underline`}
                id="title_id"
            >
                <span aria-hidden="true" className="inset-0 absolute" />
                {!!contentMarketing.text && (
                    <div className={'mb-8'}>
                        <span
                            className={`${
                                smallText ? 'text-12 md:text-14' : 'text-16'
                            } font-bold mb-0 text-left`}
                        >
                            {contentMarketing.text}
                        </span>
                    </div>
                )}
                <div className={'w-full mb-8'}>
                    <p
                        className={'balance-text mb-0'}
                        data-testid={'cm-title'}
                        ref={ref}
                    >
                        {title}
                    </p>
                </div>
            </h2>
        </div>
    );
};

export default TextContainer;
